var React = require('react');

function CarrotDown (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M3.99996 7L6.11959e-07 -2.22545e-07L8 0L3.99996 7Z","fill":"#B82216"}));
}

CarrotDown.defaultProps = {"width":"8","height":"7","viewBox":"0 0 8 7","fill":"none"};

module.exports = CarrotDown;

CarrotDown.default = CarrotDown;
